// https://stackoverflow.com/questions/66469497/gltf-setting-colors-basecolorfactor

export default {
  'pink': [
		0.6120655998656237,
		0.009021491898012131,
		0.17013837322331243,
		1
	],
	'orange': [
		0.9528999924659729,
		0.28619998693466187,
		0,
		1
	],
	'yellow': [
		0.9157501292792527,
		0.5113978188848795,
		0.000005077051900661759,
		1
	],
	'blue': [
		0.12198571316961948,
		0.18698850875884424,
		0.4704402453042184,
		1
	],
	'violet': [
		0.11392093340633272,
		0.0370285141619602,
		0.08241420588845924,
		1
	],
	'duocoat': [
		0.012286663986742496,
		0.01680700294673443,
		0.03310399502515793,
		1
	]
}
